import { render, staticRenderFns } from "./ChartPanelsGroup.vue?vue&type=template&id=3e332354&scoped=true"
import script from "./ChartPanelsGroup.vue?vue&type=script&lang=js"
export * from "./ChartPanelsGroup.vue?vue&type=script&lang=js"
import style0 from "./ChartPanelsGroup.vue?vue&type=style&index=0&id=3e332354&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e332354",
  null
  
)

export default component.exports